/**
 * cplace frontend software development kit API
 * cplace frontend software development kit API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Autocomplete Config.
 */
export interface AutocompleteConfig {
  /**
   * Type of autocomplete config.
   */
  type: AutocompleteConfig.TypeEnum;
}
export namespace AutocompleteConfig {
  export type TypeEnum = 'builtin' | 'custom';
  export const TypeEnum = {
    Builtin: 'builtin' as TypeEnum,
    Custom: 'custom' as TypeEnum,
  };
}
